/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ActivityLogsQueryVariables = Types.Exact<{
  accessRequestId: Types.Scalars['ID'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ActivityLogsQuery = { __typename: 'Query', activityLogs: { __typename: 'ActivityLogsPayload', totalCount: number, activityLogs: Array<{ __typename: 'ActivityLogDocument', id: string, startTime: any, actorName?: string | null, action: Types.ActivityLogAction, objectType: Types.ActivityLogObjectType, objectIds: Array<string>, objectNames: Array<string | null>, targetCustomerName?: string | null }> } };


export const ActivityLogsDocument = gql`
    query ActivityLogs($accessRequestId: ID!, $pageSize: Int, $pageNumber: Int) {
  activityLogs(
    accessRequestId: $accessRequestId
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    activityLogs {
      id
      startTime
      actorName
      action
      objectType
      objectIds
      objectNames
      targetCustomerName
    }
  }
}
    `;

/**
 * __useActivityLogsQuery__
 *
 * To run a query within a React component, call `useActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsQuery({
 *   variables: {
 *      accessRequestId: // value for 'accessRequestId'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useActivityLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
      }
export function useActivityLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
export type ActivityLogsQueryHookResult = ReturnType<typeof useActivityLogsQuery>;
export type ActivityLogsLazyQueryHookResult = ReturnType<typeof useActivityLogsLazyQuery>;
export type ActivityLogsQueryResult = ApolloReactCommon.QueryResult<ActivityLogsQuery, ActivityLogsQueryVariables>;